import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { FLAGS } from '@Types/flags';
import { useMemo } from 'react';
import * as routes from '../routes/routes';
import { default as useRoutes } from '../routes/useRoutes';

import Admin from './Admin';
import BulkSensor from './BulkSensor';
import CreateSystemConnection from './CreateSystemConnection';
import CreateValuemapping from './CreateValuemapping';
import EditSensor from './EditSensor/EditSensor';
import EditSensorData from './EditSensorData';
import EditSystemConnection from './EditSystemConnection';
import EditValuemapping from './EditValuemapping';
import ManageUsers from './ManageUsers';
import ManageUsersWithForm from './ManageUsers/ManageUsersWithForm';
import NewSensor from './NewSensor/NewSensor';
import UploadSensorData from './UploadSensorData';

// feature imports
import IntegrationsTab from '../features/IntegrationsTab';
import { integrationPages } from '../features/IntegrationsTab/routes/integrationPages';
import useGetIntegrationsIndex from '../features/IntegrationsTab/useGetIntegrationsIndex.hooks';
import ArcGisOauthCallback from '../features/IntegrationsTab/integrations/arcgis/ArcGisSettings/pages/ArcGisOauthCallback.page';

export * from './Admin';
export * from './BulkSensor';
export * from './CreateLiftStation';
export * from './EditSensorData';
export * from './ManageUsers';
export * from './NewUser';
export * from './SensorGroup';
export * from './UpdateLiftStation';
export * from './UpdateUser';

export { routes };
export { useRoutes };
export { ManageUsersWithForm };
export { Admin };
export { CreateSystemConnection };
export { EditSystemConnection };
export { BulkSensor };
export { NewSensor };
export { EditSensor };
export { UploadSensorData };
export { ManageUsers };
export { EditSensorData };
export { CreateValuemapping };
export { EditValuemapping };

// feature exports
export { IntegrationsTab };
export { ArcGisOauthCallback };
export { useGetIntegrationsIndex };

export function useIntegrationPages(): {
	title: string;
	to: string;
	render: JSX.Element;
}[] {
	const integrationIndex = useGetIntegrationsIndex(/integration/);
	const isIntegrationsEnabled = useIsFeatureEnabled(
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		FLAGS.ADMIN_INTEGRATIONS,
	);

	const _integrationPages = useMemo(() => {
		if (!isIntegrationsEnabled) return [];
		return integrationPages(integrationIndex || 0);
	}, [integrationIndex, isIntegrationsEnabled]);

	return _integrationPages;
}

export default { BulkSensor };
